module.exports = __webpack_public_path__ + "static/media/1.7b363e16.jpg";